var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useAppSelector } from '../../../store';
import { participantsSelector } from '../../../store/slices/participantSlice';
import sendAPIRequest from '../../../helpers/api/plugNmeetAPI';
import { ApproveWaitingUsersReq, CommonResponse, } from '../../../helpers/proto/plugnmeet_common_api_pb';
const WaitingApproval = ({ userId, name, openRemoveParticipantAlert, }) => {
    _react_refresh_temp_2();
    const participant = useAppSelector((state) => participantsSelector.selectById(state, userId));
    const { t } = useTranslation();
    const approve = async () => {
        const body = new ApproveWaitingUsersReq({
            userId: userId,
        });
        const r = await sendAPIRequest('waitingRoom/approveUsers', body.toBinary(), false, 'application/protobuf', 'arraybuffer');
        const res = CommonResponse.fromBinary(new Uint8Array(r));
        if (res.status) {
            toast(t('left-panel.menus.notice.user-approved', { name: name }), {
                type: 'info',
            });
        }
        else {
            toast(t(res.msg), {
                type: 'error',
            });
        }
    };
    const reject = () => {
        openRemoveParticipantAlert(userId, 'reject');
    };
    const render = useMemo(() => {
        if (participant === null || participant === void 0 ? void 0 : participant.metadata.wait_for_approval) {
            return (_jsxs("div", { className: "approve-btn-wrap rtl:pt-2", children: [_jsx("button", { className: "text-xs text-white py-[1px] px-2 rounded-lg transition ease-in bg-primaryColor hover:bg-secondaryColor", onClick: approve, children: t('left-panel.approve') }), _jsx("button", { className: "text-xs text-white py-[1px] px-2 rounded-lg transition ease-in bg-red-600 hover:bg-red-800 ltr:ml-2 rtl:mr-2", onClick: reject, children: t('left-panel.reject') })] }));
        }
        return null;
    }, [participant === null || participant === void 0 ? void 0 : participant.metadata.wait_for_approval]);
    return _jsx(_Fragment, { children: render });
};
_react_refresh_temp_1 = WaitingApproval;
$RefreshReg$(_react_refresh_temp_1, "WaitingApproval");
_react_refresh_temp_2(WaitingApproval, "2YSPyJx6bURG0XPUxesMo1dka7M=", false, () => [useAppSelector, useTranslation]);
export default WaitingApproval;
